export class Pager {

	constructor({
			pageBlockRange = 2,
			totalResults = 0,
			current = 1,
			perPage = 10
		}) {
		// number of page to show before and after current page
		// if at first or last page, double the number will be shown
		// either after or before
		this.pageBlockRange = pageBlockRange;
		this.totalResults = parseInt(totalResults, 10);
		this.current = parseInt(current, 10);
		this.perPage = parseInt(perPage, 10);

	}

	currentPage() {
		return this.current;
	}

	nextPage() {
		return this.atLast() ? this.current : this.current + 1;
	}

	prevPage() {
		return this.atFirst() ? this.current : this.current - 1;
	}

	validPage(num) {
		return num >= this.getFirst() && num <= this.getLast();
	}

	currentResults() {
		var start = this.current * this.perPage + 1;
		var end = start + this.perPage - 1;

		if (end > this.totalResults) {
			end = this.totalResults;
		}

		return "" + start + " - " + end;
	}

	totalPages() {
		return Math.ceil(this.totalResults / this.perPage);
	}

	getFirst() {
		return 1;
	}

	getLast() {
		return this.totalPages();
	}

	atLast() {
		return this.current === this.totalPages();
	}

	atFirst() {
		return this.current === 1;
	}

	pageData() {
		var block = [{ num: this.current, label: this.current, current: true }];

		// keep track of how many pages we're add
		// to the left or right of the current page
		var nextCount = this.current;
		var prevCount = this.current;
		for (var i = 0; i < this.pageBlockRange; i++) {
			var num;

			// add page to the left and increment prevCount
			// if page is less than first page
			// add it to the right, and increment that counter
			num = prevCount - 1;
			if (num < this.getFirst()) {
				num = nextCount + 1;
				nextCount++;
			} else {
				prevCount--;
			}

			if (this.validPage(num)) {
				block.push({ num: num, label: num, current: false });
			}

			// add page to the right and increment nextCount
			// if page is more than the last page
			// add it to the left, and increment that counter
			num = nextCount + 1;
			if (num > this.getLast()) {
				num = prevCount - 1;
				prevCount--;
			} else {
				nextCount++;
			}

			if (this.validPage(num)) {
				block.push({ num: num, label: num, current: false });
			}
		}

		return block.sort(function (a, b) {
			return a.num - b.num;
		});
	}
}

